module.exports = __webpack_public_path__ + "img/MORESTYLE.a67d2d8e.jpg";